import { AppGridCommonSearchItem, AppGridAdvancedSearch, AppSearchData as AppSearchDataProps } from 'api'

export const FilterOperatorType = { eq: 'eq', like: 'like', ge: 'ge', le: 'le', in: 'in' }

export interface AppGridSearchProps {
	defaultData?: AppSearchData[]
	defaultShowMore?: boolean
	projectFilter?: boolean
	projectFilterType?: number
	projectFilterLabel?: string
	projectFilterField?: string
	projectFilterKeyName?: string
	commonSearchList?: AppGridCommonSearchItem[]
	advancedSearch?: AppGridAdvancedSearch
	style?: React.CSSProperties
	onSearch?: (filterData: AppSearchDataProps[], data?: any) => void
}

// itemType: 'default' | 'projectFilter' | 'commonSearch' | 'text' | 'numberRange' | 'dateRange' | 'select'
// 	dataType?: 'string' | 'number' | 'date' | 'dateTime'
// 	operatorType?: string // 操作符号，预留使用
export interface AppSearchData extends AppSearchDataProps {
	showCondition?: string
	label?: string
}

export const getCommonPlaceholder = (appGridCommonSearchItemList: AppGridCommonSearchItem[]) => {
	let placeholder =
		'输入' + appGridCommonSearchItemList.map(appGridCommonSearchItem => appGridCommonSearchItem.label).join('、')
	return placeholder
}

export const getCommonFieldList = (appGridCommonSearchItemList: AppGridCommonSearchItem[]) => {
	return appGridCommonSearchItemList.map(appGridCommonSearchItem => appGridCommonSearchItem.field)
}

export const getValue = (appSearchDataList: AppSearchData[], keyName: string) => {
	let appSearchData = appSearchDataList.find(o => o.keyName === keyName)
	if (appSearchData) return appSearchData.value.toString() || ''
	return ''
}

export const getSearchData = (appSearchDataList: AppSearchData[], keyName: string) => {
	return appSearchDataList.find(o => o.keyName === keyName)!
}

export const getCondition = (minValue: any, maxValue: any) => {
	if (minValue && maxValue) {
		return `${minValue}-${maxValue}`
	} else if (minValue && !maxValue) {
		return `大于等于 ${minValue}`
	} else if (!minValue && maxValue) {
		return `小于等于 ${maxValue}`
	} else {
		return ''
	}
}

export const getFilterData = (appSearchDataList: AppSearchData[]) => {
	return appSearchDataList
}

export const getSearchObject = (appSearchDataList: AppSearchData[]) =>{
	let SearchObject ={} as any;
	if(appSearchDataList && appSearchDataList.length>0){
		appSearchDataList.forEach((data:AppSearchData)=>{
			SearchObject[data.keyName] = data.value;
		})
	}
	return SearchObject;
}



// WEBPACK FOOTER //
// ./src/components/AppTableSearch/AppGridSearchData.tsx